import type { AnyRouter } from "@tanstack/react-router";

let current: AnyRouter | null = null;

// main 이 만든 라우터를 기억한다 — React 밖(rpc 봉투의 이동)에서 화면을 옮길 때 쓴다.
export const setRouter = (router: AnyRouter | null): void => {
  current = router;
};

// 지금 불러오는(또는 마지막으로 연) 라우터 주소 — loader 의 대상 경로 · 라우터 전이면 undefined.
export const pendingHref = (): string | undefined => current?.latestLocation?.href;

export const navigateTo = (href: string, replace = false): void => {
  if (current) void current.navigate({ href, replace });
  else window.location.assign(href);
};
